import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteFuelTransactionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  transactionNumber: string
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteFuelTransactionDialog({
  open,
  onOpenChange,
  transactionNumber,
  onConfirm,
  isDeleting,
}: DeleteFuelTransactionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Fuel Transaction</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete fuel transaction{' '}
            <span className="font-mono font-medium">{transactionNumber}</span>?
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
